import { config } from "../config/config";
import { Model3D } from "../models/Model3D";

export const availableModels: Record<string, Model3D> = {
  mclaren: {
    name: 'McLaren Senna',
    imagePath: config.baseModelPath + 'mclaren.png',
    metadata: {
      initialViewPoint: {
        position: [5, 3, 1],
        target: [0, 0, 0]
      },
      boundary: {
        exclusion: {
          center: [0, 1, 0],
          dimension: [4, 2, 7],
        },
        inclusion: {
          center: [0, 5.1, 0],
          dimension: [20, 10, 20],
        }
      },
      interactions: [{
        name: 'openAll',
        type: 'floatingIcon',
        stateRequirement: {
          doorOpened: false
        },
        icon: {
          name: 'openDoor',
          position: [0, 2, 0],
        },
        action: {
          toggleStates: ['doorOpened'],
          boundary: {
            exclusion: {
              center: [0, 1, 0],
              dimension: [3, 2, 6]
            }
          },
        }
      }, {
        name: 'closeAll',
        type: 'floatingIcon',
        stateRequirement: {
          doorOpened: true
        },
        icon: {
          name: 'closeDoor',
          position: [0, 2, 0],
        },
        action: {
          toggleStates: ['doorOpened']
        }
      }, {
        name: 'enterCar',
        type: 'floatingIcon',
        stateRequirement: {
          doorOpened: true,
          inside: false,
        },
        icon: {
          name: 'enter',
          position: [0, 1, 0],
        },
        action: {
          toggleStates: ['inside'],
          boundary: {
            inclusion: {
              center: [0, 0.8, 0.3],
              dimension: [2, 1, 1]
            }
          },
          moveCamera: {
            position: [0, 1, 0],
            target: [0, 1, 1]
          }
        }
      }, {
        name: 'exitCar',
        type: 'floatingIcon',
        stateRequirement: {
          inside: true,
        },
        icon: {
          name: 'exit',
          position: [0, 1.2, 1]
        },
        action: {
          toggleStates: ['inside'],
          boundary: null,
          moveCamera: null
        }
      }, {
        name: 'backLeftTire',
        type: 'floatingIcon',
        stateRequirement: {
          backLeftTire: false
        },
        icon: {
          name: 'search',
          position: [2, 0.5, -2],
        },
        action: {
          moveCamera: {
            position: [2.5, 0.63, -2],
            target: [1, 0.3, -2],
          },
          toggleStates: ['backLeftTire'],
          boundary: {
            inclusion: {
              center: [2.25, 0.5, -2],
              dimension: [1, 1, 1.5]
            }
          }
        }
      }, {
        name: 'backLeftTireBack',
        type: 'floatingIcon',
        stateRequirement: {
          backLeftTire: true
        },
        icon: {
          name: 'exit',
          position: [1.4, 0.1, -2.7],
        },
        action: {
          moveCamera: null,
          toggleStates: ['backLeftTire'],
          boundary: null
        }
      }, {
        name: 'frontLeftTire',
        type: 'floatingIcon',
        stateRequirement: {
          frontLeftTire: false
        },
        icon: {
          name: 'search',
          position: [2, 0.5, 1.6],
        },
        action: {
          moveCamera: {
            position: [2.5, 0.63, 1.6],
            target: [1, 0.3, 1.6],
          },
          toggleStates: ['frontLeftTire'],
          boundary: {
            inclusion: {
              center: [2.25, 0.5, 1.6],
              dimension: [1, 1, 1.5]
            }
          }
        }
      }, {
        name: 'frontLeftTireBack',
        type: 'floatingIcon',
        stateRequirement: {
          frontLeftTire: true
        },
        icon: {
          name: 'exit',
          position: [1.4, 0.1, 2.3],
        },
        action: {
          moveCamera: null,
          toggleStates: ['frontLeftTire'],
          boundary: null
        }
      }, {
        name: 'backRightTire',
        type: 'floatingIcon',
        stateRequirement: {
          backRightTire: false
        },
        icon: {
          name: 'search',
          position: [-2, 0.5, -2],
        },
        action: {
          moveCamera: {
            position: [-2.5, 0.63, -2],
            target: [-1, 0.3, -2],
          },
          toggleStates: ['backRightTire'],
          boundary: {
            inclusion: {
              center: [-2.25, 0.5, -2],
              dimension: [1, 1, 1.5]
            }
          }
        }
      }, {
        name: 'backRightTireBack',
        type: 'floatingIcon',
        stateRequirement: {
          backRightTire: true
        },
        icon: {
          name: 'exit',
          position: [-1.4, 0.1, -2.7],
        },
        action: {
          moveCamera: null,
          toggleStates: ['backRightTire'],
          boundary: null
        }
      }, {
        name: 'frontRightTire',
        type: 'floatingIcon',
        stateRequirement: {
          frontRightTire: false
        },
        icon: {
          name: 'search',
          position: [-2, 0.5, 1.6],
        },
        action: {
          moveCamera: {
            position: [-2.5, 0.63, 1.6],
            target: [-1, 0.3, 1.6],
          },
          toggleStates: ['frontRightTire'],
          boundary: {
            inclusion: {
              center: [-2.25, 0.5, 1.6],
              dimension: [1, 1, 1.5]
            }
          }
        }
      }, {
        name: 'frontRightTireBack',
        type: 'floatingIcon',
        stateRequirement: {
          frontRightTire: true
        },
        icon: {
          name: 'exit',
          position: [-1.4, 0.1, 2.3],
        },
        action: {
          moveCamera: null,
          toggleStates: ['frontRightTire'],
          boundary: null
        }
      }, {
        name: 'engineCap',
        type: 'floatingIcon',
        stateRequirement: {
          doorOpened: true,
          engineCap: false,
        },
        icon: {
          name: 'search',
          position: [0, 1, 3]
        },
        action: {
          moveCamera: {
            position: [0, 1.5, 4],
            target: [0, 0.5, 2]
          },
          toggleStates: ['engineCap'],
          boundary: {
            inclusion: {
              center: [0, 1.5, 3.5],
              dimension: [2, 1, 1]
            }
          }
        }
      }, {
        name: 'engineCapBack',
        type: 'floatingIcon',
        stateRequirement: {
          doorOpened: true,
          engineCap: true,
        },
        icon: {
          name: 'exit',
          position: [0, 0.8, 2.5]
        },
        action: {
          moveCamera: null,
          toggleStates: ['engineCap'],
          boundary: null
        }
      }, {
        name: 'trunk',
        type: 'floatingIcon',
        stateRequirement: {
          doorOpened: true,
          trunk: false,
        },
        icon: {
          name: 'search',
          position: [0, 0.8, -3.5]
        },
        action: {
          moveCamera: {
            position: [0, 1.5, -4],
            target: [0, 0.8, -3]
          },
          toggleStates: ['trunk'],
          boundary: {
            inclusion: {
              center: [0, 1, -4],
              dimension: [2, 1, 1],
            }
          }
        }
      }, {
        name: 'trunkBack',
        type: 'floatingIcon',
        stateRequirement: {
          doorOpened: true,
          trunk: true,
        },
        icon: {
          name: 'exit',
          position: [0, 0.8, -3.2]
        },
        action: {
          moveCamera: null,
          toggleStates: ['trunk'],
          boundary: null,
        }
      }, {
        name: 'doorFrameLeft',
        type: 'floatingIcon',
        stateRequirement: {
          doorOpened: true,
          doorFrameLeft: false,
        },
        icon: {
          name: 'search',
          position: [1.5, 0.5, 0.5]
        },
        action: {
          moveCamera: {
            position: [1.8, 1, 0.5],
            target: [1.3, 0.3, 0.5]
          },
          toggleStates: ['doorFrameLeft'],
          boundary: {
            inclusion: {
              center: [1.3, 0.8, 0.5],
              dimension: [1, 1, 1],
            }
          }
        }
      }, {
        name: 'doorFrameLeftBack',
        type: 'floatingIcon',
        icon: {
          name: 'exit',
          position: [1.5, 0.3, 0.8]
        },
        stateRequirement: {
          doorOpened: true,
          doorFrameLeft: true,
        },
        action: {
          moveCamera: null,
          toggleStates: ['doorFrameLeft'],
          boundary: null,
        }
      }, {
        name: 'doorFrameRight',
        type: 'floatingIcon',
        stateRequirement: {
          doorOpened: true,
          doorFrameRight: false,
        },
        icon: {
          name: 'search',
          position: [-1.5, 0.5, 0.5]
        },
        action: {
          moveCamera: {
            position: [-1.8, 1, 0.5],
            target: [-1.3, 0.3, 0.5]
          },
          toggleStates: ['doorFrameRight'],
          boundary: {
            inclusion: {
              center: [-1.3, 0.8, 0.5],
              dimension: [1, 1, 1],
            }
          }
        }
      }, {
        name: 'doorFrameRightBack',
        type: 'floatingIcon',
        icon: {
          name: 'exit',
          position: [-1.5, 0.3, 0.8]
        },
        stateRequirement: {
          doorOpened: true,
          doorFrameRight: true,
        },
        action: {
          moveCamera: null,
          toggleStates: ['doorFrameRight'],
          boundary: null,
        }
      }],
      components: {
        leftDoor: {
          onClickActions: [{
            type: 'animation',
            name: 'leftDoorAction',
          }]
        },
        rightDoor: {
          onClickActions: [{
            type: 'animation',
            name: 'rightDoorAction',
          }]
        },
        engineCap: {
          onClickActions: [{
            type: 'animation',
            name: 'engineCapAction',
          }]
        },
        engine: {
          visibilityRequirements: ['engineCap']
        },
        interior: {
          visibilityRequirements: ['leftDoor', 'rightDoor']
        }
      },
      assets: [{
        name: 'base',
        path: config.baseModelPath + "mclaren.glb",
        stateRequirement: {
          doorOpened: false,
        },
      }, {
        name: 'baseOpenDoor',
        path: config.baseModelPath + "mclaren.open-door.glb",
        stateRequirement: {
          doorOpened: true,
        },
      }, {
        name: 'detailedBackLeftTire',
        path: config.baseModelPath + "mclaren.back-left-tire.glb",
        stateRequirement: {
          backLeftTire: true,
        },
      }]
    }
  },
  // mercedez: {
  //   path: config.baseModelPath + "mercedes-benz.glb",
  //   name: 'Mercedes Benz',
  //   imagePath: config.baseModelPath + 'mercedes-benz.png',
  //   metadata: {
  //     components: {
  //       leftDoor: {
  //         onClickActions: [{
  //           type: 'animation',
  //           name: 'leftDoorAction',
  //         }]
  //       },
  //       rightDoor: {
  //         onClickActions: [{
  //           type: 'animation',
  //           name: 'rightDoorAction',
  //         }]
  //       },
  //       engineCap: {
  //         onClickActions: [{
  //           type: 'animation',
  //           name: 'engineCapAction',
  //         }]
  //       },
  //       trunk: {
  //         onClickActions: [{
  //           type: 'animation',
  //           name: 'trunkAction'
  //         }]
  //       }
  //     }
  //   }
  // },
};
